export default {
  please_sel: '请选择',
  card_title1: '取款',
  local: '香港银行账户取款',
  oversea_tip: '非香港银行卡取款可能会被银行拒收并收取一定的手续费，请确认是否取款',
  success: '您的取款申请已经提交，如有问题请与我们联系',
  oversea: '非香港银行账户取款',
  card_title2: '最近转出记录',
  view_more: '查看更多',
  account_number: '交易账户',
  accountNumber: '客户编码',
  tradeAccount: '交易账户',
  acceptableAmount: '建议最大可提金额',
  availableAmount: '可取款额度',
  withdrawal_amount: '取款金额',
  bank_card_number: '银行卡号',
  confirm_title: '检查信息',
  confirm_sub_title: '请确认信息并提交信息',
  button_confirm: '确认',
  button_edit: '编辑',
  button_submit: '提交',
  error_withdrawal_amount: '取款金额不得大于对应币种的可取款额度',
  error_withdrawal_amount_mt5: '取款金额不得大于可用预付款',
  error_withdrawal_check: '还有未处理的取款订单',
  error_submit: '提交申请失败',
  error_withdrawal_amount_1: '请填写取款金额',
  error_withdrawal_amount_2: '金额不能小于0.01',
  error_withdrawal_amount_3: '金额只能输入2位小数',
  error_withdrawal_amount_total: '取款金额不得大于所有币种加总的可取额度，预计为{total}',
  error_account_number: '请选择交易账户',
  error_bank_card_number: '请选择收款账户',
  error_withdrawal_name: '请填写英文名/中文拼音',
  error_withdrawal_bank_name: '请填写银行名称',
  error_withdrawal_bank_card: '请填写收款账号',
  error_withdrawal_swift_no: '请填写Swift代码',
  error_bank_card_name: '请填写银行名称',
  noWithdrawal: '无取款记录',
  other_bank_card_name: '银行名称',
  other_bank_card_number: '银行账号',
  other_bank_card_name_placeholder: '请填写银行名称',
  other_bank_card_number_placeholder: '请填写银行账号',
  note: '提款申请注意事项：</br>' +
    '<b>1、客户如欲提取交易账户内之资金，请提交取款申请。艾德证券期货将以户口持有人抬头发出支票。 </b></br>' +
    '2、艾德证券期货(“本公司”)的提款申请截止时间一般为星期一至五（香港公众假期、圣诞前夕、除夕及农历新年前夕除外）每日下午2时, 任何于下午2时后收到的提款申请将于下一个工作天处理。香港银行结算日为星期一至五，不包括香港公众假期、圣诞前夕、除夕及农历新年前夕。 </br>' +
    '3、艾德证券期货不接受第三者提款。请确保银行账户姓名与艾德证券期货开户申请书上的姓名相符。 </br>' +
    '4、支票的结算时间最少为两个结算日。香港银行结算日为星期一至五（香港公众假期、圣诞前夕、除夕等除外）。 </br>' +
    '5、如欲亲身领取支票，请致电 +852 2655 0338 / 400 120 0068（中国内地免费热线）预约。</br>' +
    '6、如因资料或档不完整而导致提款申请的处理出现延误或未能处理该提款申请，或任何其他情况，客户需自行承担责任。</br>' +
    '7、反洗钱警告: 如客户的交易账户在存款后没有进行正常交易活动后作出提款申请，已有可能涉及洗钱活动。艾德证券期货有可能将账户停用或取消。',
  oversea_note: '提款申请注意事项：</br>' +
    '<b>1、艾德证券期货(“本公司”)的提款申请截止时间一般为星期一至五（香港公众假期、圣诞前夕、除夕及农历新年前夕除外）每日下午2时, 任何于下午2时后收到的提款申请将于下一个工作天处理。香港银行结算日为星期一至五，不包括香港公众假期、圣诞前夕、除夕及农历新年前夕。 </b></br>' +
    '2、艾德证券期货不接受第三者提款。请确保银行账户姓名与艾德证券期货开户申请书上的姓名相符。 </br>' +
    '3、如因资料或档不完整而导致提款申请的处理出现延误或未能处理该提款申请，或任何其他情况，客户需自行承担责任。 </br>' +
    '4、境外提款到账时间需时较长，请留意收款银行通知。</br>' +
    '5、反洗钱警告:如客户的交易账户在存款后没有进行正常交易活动后作出提款申请，已有可能涉及洗钱活动。艾德证券期货有可能将账户停用或取消。</br>',
  name: '英文名/中文拼音',
  bankName: '银行名称',
  bankNo: '银行账户',
  swiftNo: 'SWIFT Code（银行国际代码)',
  withdrawalCare: '银行可能会收取手续费，费用由客户自行承担',
  balanceLow: '没有余额',
  error_withdrawal_email: '数据创建成功，邮件发送失败',
  haveRead: '本人已阅读，知悉及明白「跨境提款相关费用明细」',
  withdrawalTipsTitle: '跨境提款相关费用明细',
  withdrawalTips: {
    wireTransfer: {
      title: '手续费(银行及本公司收取)',
      tips: '本公司会一律每次收取港币350元/美金45元/其他等值货币的银行转账手续费。(如收款银行拒收而出现退回情况，已收取手续费将不予退回)'
    },
    other: {
      title: '其他收费(银行收取)',
      tips: '银行有可能收费行政费用,视乎有关银行的政策而订。客户需向其汇款银行查询。'
    },
    exchangePriceDifferenceBank: {
      title: '兑换差价(银行收取)',
      tips: '如客户取款货币与其银行户口货币不同,当中可能产生兑换差价。',
      example: '如:客户提取美元到其人民币银行户口，银行会以其汇率兑换客户之美元至人民币，当中可能产生兑换差价。客户需向其汇款银行查询。'
    },
    exchangePriceDifferenceCompany: {
      title: '兑换差价(本公司收取)',
      tips: '如客户取款货币与其交易帐户结算货币不同,本公司会以本公司适用的银行汇率兑换其存款为交易帐户结算货币后进行取款,过程中有可能产生兑换差价。',
      example: '如:客户交易帐户以美元作为结算货币，所有港元/人民币取款将会以本公司适用的银行汇率兑换成美元并于您的交易帐户内扣除。'
    },
    uploadTips: {
      tip1: '如欲提取超过港币可取款额度的金额，请先自行将其他货币现金结余换汇后再提款，如有需要请联络客服',
      mt5Tip: '最终实际提款金额会以港币汇出，如有其它需要请联络客服。',
      uploadTitle: '上传收款银行证明(必须包含银行名称、银行账号及阁下姓名全名)',
      tip2: '证明文件可以是：',
      tip3: '1.  印有阁下姓名和银行账号的提款卡正面。',
      tip4: '2. 印有发出日期（3个月内）的银行开户信件；或',
      tip5: '3. 印有发出日期（3个月内）的银行月结单副本/电子月结单；或',
      tip6: '为了保障您的账户安全，如您递交的证明文件不符合要求，客服会第一时间与您联系，如您之前已经递交过证明文件则不必重复递交。'
    }
  },
  irregular_rules_bank_card_number: '银行卡号只能输入数字或者-!',
  irregular_rules_bank_card_name: '请输入正确的银行名称!',
  imageKeysIsRequired: '请上传收款银行证明!',
  largestAmount: '为降低提款后账户资金紧张而短期内出现强制平仓的风险，此为建议最大提取金额。同时，提取之金额不可大于账户「可用保证金」金额。',
  liquidation: '由于市场价格波动, 转出目前要求的金额有机会令账户在短时间内触发强制平仓',
  konwtext: '我明白市场价格波动有可能导致账户在提款过程中或之后触发强制平仓, 我了解并接受相关之风险, 请继续转出资金。',
  checkInfo: '请先点击勾选项',
  bandBank: '本人确认将此银行登记为出金绑定银行',
  warnBandBank: '注：如因任何原因导致此次出金失败，将不会为阁下绑定此银行。',
  otherTip: `<div style="margin-top: 8px;">{}.如阁下收款银行地区为澳洲但未有填写收款银行位址，若发生银行退款，可能导致退款时间延长。</div>`,
  unhkServiceFee: '银行转账手续费',
  actualAmountCredited: '(*实际到账金额以银行为准)'
}
